<template>
  <div class="notfound has-text-centered">
    <h3 class="title is-3">404 | Not Found</h3>
    <img src="@/assets/404.png" alt="404" />
  </div>
</template>
<style scoped>
.notfound {
  margin-top: 5rem;
  margin-bottom: auto;
}
</style>
